export default __webpack_public_path__ + "static/media/withdraw-reward-step4-option1.b7828402.png";